export enum PortalExperience {
  Caseworker = 'caseworker',
  ForeignNational = 'foreign_national',
  Client = 'client'
}
